import { render } from "./EditProduct.vue?vue&type=template&id=09f45bcc"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__